export const PROJECT_DOCUMENTS_CHANGED_EVENT = 'project-documents-changed';

export function notifyProjectDocumentsChanged(projectId) {
    if (!projectId) {
        return;
    }
    window.dispatchEvent(
        new CustomEvent(PROJECT_DOCUMENTS_CHANGED_EVENT, {
            detail: { projectId: String(projectId) },
        }),
    );
}
